import React from 'react';

class AUFOfferings extends React.Component {
  constructor(props) {
    super();

    this.dispatchReducer = props.dispatchReducer.bind(this);

    this._genOfferingItem = this._genOfferingItem.bind(this);
    this._handleSelectChange = this._handleSelectChange.bind(this);
  }

  render() {

    return <fieldset>
      <legend className="sq-form-question-title">Offerings</legend>

      <div className="sq-form-question-answer overflow-scroll filterOffering">
        <ul>
          {this.props.offerings.map(function(item, i) {

            return this._genOfferingItem(item, i);
          }, this)}
        </ul>
      </div>
    </fieldset>;
  }

  _genOfferingItem(item, i) {
    let itemName = 'offering',
      itemId = 'offer-' + item.trimester.toLowerCase().replace(/\s+/g, '-'),
      value = item.trimester,
      isChecked = this.props.currOffering.indexOf(value) > -1,
      label = item.year + ', ' + item.trimester,
      unConfirmMsg = item.status === 'Unconfirmed' ? ' (Subject to Availability)' : '',
      overlay = isChecked && this.props.currOffering.length <= 1 ? <span className="checkbox-overlay"></span> : null;

    return <li key={i} className={ overlay === null ? '' : 'has-checkbox-overlay'}>
      <input type="checkbox"
             value={value}
             name={itemName}
             id={itemId}
             onChange={this._handleSelectChange}
             checked={isChecked} />

      <label htmlFor={itemId} className="p--bg-white">{label}{unConfirmMsg}</label>
      { overlay }
    </li>;
  }

  _handleSelectChange(e) {
    let currOffering = e.target.value;

    this.dispatchReducer({
      type:       'ALL_UNITS_OFFERING::UPDATE',
      value:      currOffering,
      fireFilter: true
    });
  }
}

AUFOfferings.propTypes = {
  currOffering:     React.PropTypes.array.isRequired,
  offerings:        React.PropTypes.array.isRequired,
  dispatchReducer:  React.PropTypes.func.isRequired
}

export default AUFOfferings;